// extracted by mini-css-extract-plugin
export default {"actions":"Actions_actions__6b1qM","title":"Actions_title__LWZIY"};